import { gql, useQuery } from '@apollo/client'
import qs from 'qs'
import { useEffect } from 'react'
import { COACH_TOOLS_API } from '../../../../apolloClient'
import { BACKGROUND_CHECK_ORDER_FRAGMENT } from '../../../../utils/prospect/withProspectQuery'
import { StatusLink } from './styles'
import { Button } from '@pga/pga-component-library'
import { useModal } from '../../../../components/Dashboard/JobSeekerDashboard/ModalContext'

export const LINK_TEST_ID = 'background-check-departure-link'

export const BACKGROUND_CHECK_ORDER_QUERY = gql`
  query ProspectQuery {
    currentMember {
      prospect {
        backgroundCheckOrder {
          ${BACKGROUND_CHECK_ORDER_FRAGMENT}
        }
      }
    }
  }
`

export const BackgroundCheckDepartureLink = ({ order, presentation }) => {
  const { openModal } = useModal()
  const { backgroundCheckConfirmation } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true
  })

  useEffect(() => {
    if (backgroundCheckConfirmation) {
      openModal('backgroundCheck')
    }
  }, [backgroundCheckConfirmation, openModal])

  const monitorOrderStatus = !!order?.paidAt && !order?.awaitingModeration

  useQuery(BACKGROUND_CHECK_ORDER_QUERY, {
    context: { api: COACH_TOOLS_API },
    skip: !monitorOrderStatus,
    pollInterval: 5000
  })

  const isPaid = !!order?.paidAt
  const CallToAction = presentation === 'button' ? Button : StatusLink

  if (order?.awaitingModeration) {
    return null
  }

  return (
    <CallToAction
      onClick={() => openModal('backgroundCheck')}
      data-testid={LINK_TEST_ID}
    >
      {isPaid ? 'Continue Background Check' : 'Start Background Check'}
    </CallToAction>
  )
}

export default BackgroundCheckDepartureLink
